/* HomeMedix pay switch (Oct 12, 2026; buy-box steps 2 + 4). Markup: snippets/pdp-pay-choice.liquid; styles: assets/hm-pay-switch.css.
   Pay retail | Use insurance switch. "Use insurance" shows the insurance view INSIDE the buy box (.hmps-ins) and sets
   html[data-hm-pay-mode=insurance], which hides price, options, the Rx card and the buy buttons (hm-pay-switch.css).
   "Pay retail" brings them back; picked state / plan stay filled in.
   Network result (look C, 'Shopify - PDP Insurance Box Polish.html'): same card as the Rx card. In network = brand 'Verify'
   illustration (Files: hm-verify.png), next step + prescription note, generic-item tick in the bottom bar (first sentence;
   Learn more opens the rest), then an always-blue "Continue with insurance": clicked before the tick, the card turns red with
   "Please tick the box to continue." Not in network = amber chip, Buy retail + Request we join your network in the bar.
   Step 4: Add to cart / Shop Pay are never greyed. Until the Rx box is ticked, adding THIS product is stopped three ways,
   and the card turns red with a message:
     1. click on Add to cart / Shop Pay / the phone sticky bar (window capture),
     2. submit of a /cart/add form for this product (Enter in the quantity box, requestSubmit, apps),
     3. fetch('/cart/add') carrying one of this product's variant ids (sticky-bar apps, quick-add apps) -> answered with a 422
        so Dawn's product form just stops its spinner.
   html[data-hm-pay-mode] = retail-pending | retail-unlocked | insurance (the inline snippet script sets 'retail-locked' for
   the instant before this file runs). */
(function () {
  if (window.__hmPsInit) return;
  window.__hmPsInit = true;
  var S = { open: false, rxAck: false, err: false, st: null, py: null, res: null, sub: false, subErr: false, more: false };
  var timer = null, lastFocus = null, cfg = null;
  var ATC = '.product-form__submit, .shopify-payment-button, .shopify-payment-button__button, [data-shopify="payment-button"]';
  var OKART = 'https://cdn.shopify.com/s/files/1/0600/4568/8925/files/hm-verify.png?v=1791841167&width=112';
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function conf() {
    if (cfg) return cfg;
    try { cfg = JSON.parse(q('[data-hmps-config]').textContent); } catch (e) { cfg = { payers: [], eligibility: '/pages/eligibility-check', form: '#', handle: '', price: '' }; }
    return cfg;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function inNet(p) { return !!p && p !== '__unlisted__' && conf().payers.indexOf(p) !== -1; }
  function needsAck() { return !S.rxAck && !!q('[data-hmps-rxco]'); }
  function rxIds() {
    var ids = [];
    try { (window.ShopifyAnalytics.meta.product.variants || []).forEach(function (v) { ids.push(String(v.id)); }); } catch (e) { /* ignore */ }
    qa('.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (i) { if (i.value) ids.push(String(i.value)); });
    return ids;
  }
  function bodyIds(body) {
    var out = [];
    try {
      if ((typeof FormData !== 'undefined' && body instanceof FormData) || (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams)) {
        if (body.get('id')) out.push(String(body.get('id')));
        if (body.get('items[0][id]')) out.push(String(body.get('items[0][id]')));
      } else if (typeof body === 'string' && body.length) {
        var t = body.replace(/^\s+/, '');
        if (t.charAt(0) === '{' || t.charAt(0) === '[') {
          var o = JSON.parse(t), items = Array.isArray(o) ? o : (o.items || [o]);
          items.forEach(function (it) { if (it && it.id != null) out.push(String(it.id)); });
        } else {
          var p = new URLSearchParams(t);
          if (p.get('id')) out.push(String(p.get('id')));
        }
      }
    } catch (e) { /* ignore */ }
    return out;
  }
  function lift() {
    ['rx', 'ins'].forEach(function (name) {
      var els = qa('[data-hmps-modal="' + name + '"]'), keep = null;
      els.forEach(function (el) { if (!keep && el.parentNode === document.body) keep = el; });
      els.forEach(function (el) {
        if (!keep) { keep = el; document.body.appendChild(el); }
        else if (el !== keep && el.parentNode) el.parentNode.removeChild(el);
      });
    });
  }
  function errMsg() {
    qa('[data-hmps-rxco]').forEach(function (co) {
      if (co.querySelector('.hmps-err')) return;
      var m = document.createElement('p');
      m.className = 'hmps-err';
      m.setAttribute('role', 'alert');
      m.hidden = true;
      m.textContent = 'Please tick the box to add this to your cart.';
      co.appendChild(m);
    });
  }
  function url() {
    var c = conf(), p = new URLSearchParams();
    p.set('handle', c.handle || '');
    if (S.st) p.set('state', S.st);
    if (S.py && S.py !== '__unlisted__') p.set('payer', S.py);
    var v = q('.product-variant-id');
    if (v && v.value) p.set('variant', v.value);
    return c.eligibility + '?' + p.toString();
  }
  function result() {
    var box = q('[data-hmps-result]');
    if (!box) return;
    var bad = S.subErr && !S.sub;
    if (S.res === 'in') {
      box.innerHTML = '<div class="hmps-rc hmps-card' + (S.sub ? ' is-ok' : '') + (bad ? ' is-err' : '') + '" data-hmps-subgrp>'
        + '<div class="hmps-card__top"><span class="hmps-chip hmps-chip--art" aria-hidden="true"><img src="' + OKART + '" alt="" width="48" height="48"></span><div><b class="hmps-card__t">' + esc(S.py) + ' is in our network</b>'
        + '<span class="hmps-card__s">Next we&rsquo;ll verify your exact plan and show your estimated out-of-pocket cost before anything is billed.<em class="hmps-rc__rx">Your prescription is collected as part of the insurance process &mdash; no need to upload it here.</em></span></div></div>'
        + '<div class="hmps-card__bar"><label class="hmps-ck hmps-ck--sub"><input type="checkbox" data-hmps-sub' + (S.sub ? ' checked' : '') + '><span>I understand my insurance may cover a different brand of this same product type. <a href="#" data-hmps-more>' + (S.more ? 'Show less' : 'Learn more') + '</a></span></label>'
        + '<p class="hmps-more"' + (S.more ? '' : ' hidden') + '>If so, I&rsquo;ll receive an item that works the same way and matches my prescription &mdash; just like a pharmacy filling a generic instead of a name brand. If a substitution is ever needed, we&rsquo;ll confirm with you before anything ships &mdash; you&rsquo;ll never be surprised by what arrives.</p></div>'
        + '<p class="hmps-err" role="alert"' + (bad ? '' : ' hidden') + '>Please tick the box to continue.</p></div>'
        + '<a href="' + esc(url()) + '" class="hmps-go" data-hmps-go>Continue with insurance &rarr;</a>'
        + '<p class="hmps-gonote">Takes about 2 minutes &middot; no payment needed today</p>';
    } else if (S.res === 'out') {
      box.innerHTML = '<div class="hmps-rc hmps-card"><div class="hmps-card__top"><span class="hmps-chip hmps-chip--warn" aria-hidden="true">!</span><div><b class="hmps-card__t">We may not be in your insurer&rsquo;s network</b>'
        + '<span class="hmps-card__s"><strong>That doesn&rsquo;t mean you&rsquo;re not covered</strong> &mdash; it just means we can&rsquo;t bill your plan directly. You can buy it retail today, or contact your insurance to get referred to a DME supplier in their network.</span></div></div>'
        + '<div class="hmps-card__bar hmps-rc__acts"><button type="button" class="hmps-ob" data-hmps-buyretail>Buy retail &middot; ' + esc(conf().price) + '</button><a href="' + esc(conf().form) + '" target="_blank" rel="noopener">Request we join your network &rarr;</a>'
        + '<p class="hmps-nonote">Tell us your plan in a 1-minute form &mdash; we&rsquo;ll follow up when we can bill it.</p></div></div>';
    } else {
      box.innerHTML = '';
    }
    var d = q('[data-hmps-disc]');
    if (d) d.hidden = !!S.res;
  }
  function check() {
    clearTimeout(timer);
    if (!S.st || !S.py) { S.res = null; result(); return; }
    var box = q('[data-hmps-result]');
    if (box) box.innerHTML = '<div class="hmps-checking"><span class="hmps-sp" aria-hidden="true"></span>Checking your insurer&rsquo;s network&hellip;</div>';
    timer = setTimeout(function () { S.res = inNet(S.py) ? 'in' : 'out'; S.sub = false; S.subErr = false; S.more = false; result(); }, 650);
  }
  function apply() {
    var mode = S.open ? 'insurance' : 'retail';
    if (S.rxAck) S.err = false;
    qa('[data-hmps-pay]').forEach(function (b) {
      var on = b.getAttribute('data-hmps-pay') === mode;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    qa('[data-hmps-ins]').forEach(function (el) { el.hidden = !S.open; });
    document.documentElement.classList.toggle('hmps-lock', !!q('[data-hmps-modal]:not([hidden])'));
    qa('[data-hmps-rxack]').forEach(function (c) { c.checked = S.rxAck; });
    qa('[data-hmps-rxco]').forEach(function (c) {
      c.classList.toggle('is-ok', S.rxAck);
      c.classList.toggle('is-err', S.err);
      var m = c.querySelector('.hmps-err');
      if (m) m.hidden = !S.err;
    });
    if (S.open) document.documentElement.setAttribute('data-hm-pay-mode', 'insurance');
    else if (q('[data-hmps-rxco]')) document.documentElement.setAttribute('data-hm-pay-mode', S.rxAck ? 'retail-unlocked' : 'retail-pending');
  }
  function setMode(ins) { if (S.open === ins) return; S.open = ins; apply(); }
  function refocus() { if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* ignore */ } } lastFocus = null; }
  function openModal(name) {
    lift();
    var w = q('[data-hmps-modal="' + name + '"]');
    if (!w) return;
    lastFocus = document.activeElement;
    w.hidden = false;
    apply();
    setTimeout(function () { var c = q('[data-hmps-mclose]', w); if (c) c.focus(); }, 30);
  }
  function closeModal() {
    var w = q('[data-hmps-modal]:not([hidden])');
    if (!w) return false;
    w.hidden = true;
    apply();
    refocus();
    return true;
  }
  function nudge(el) {
    if (!el) return;
    el.classList.remove('is-nudge');
    void el.offsetWidth;
    el.classList.add('is-nudge');
    clearTimeout(el.__hmT);
    el.__hmT = setTimeout(function () { el.classList.remove('is-nudge'); }, 1400);
  }
  function reveal(el) {
    if (!el) return;
    var r = el.getBoundingClientRect();
    if (r.top < 90 || r.bottom > window.innerHeight - 40) {
      window.scrollTo({ top: window.pageYOffset + r.top - Math.max(90, (window.innerHeight - r.height) / 2), behavior: 'smooth' });
    }
  }
  function block() {
    S.err = true;
    apply();
    var co = q('[data-hmps-rxco]');
    reveal(co);
    nudge(co);
    var ck = q('[data-hmps-rxack]');
    if (ck) { try { ck.focus({ preventScroll: true }); } catch (_e) { /* ignore */ } }
  }
  /* 3. network guard (outermost fetch wrapper; pdp-rx-cart-property's wrapper still runs for allowed requests) */
  if (typeof window.fetch === 'function' && !window.__hmPsFetch) {
    window.__hmPsFetch = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (u.indexOf('/cart/add') !== -1 && needsAck() && init && init.body != null) {
          var ids = rxIds();
          if (bodyIds(init.body).some(function (id) { return ids.indexOf(id) !== -1; })) {
            block();
            return Promise.resolve(new Response(JSON.stringify({ status: 422, message: 'Prescription acknowledgement required', description: '' }), { status: 422, headers: { 'Content-Type': 'application/json' } }));
          }
        }
      } catch (e) { /* fall through */ }
      return origFetch.apply(this, arguments);
    };
  }
  /* 2. form submit guard */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!needsAck() || !f || !f.getAttribute) return;
    if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var id = f.querySelector('input[name="id"]');
    if (id && id.value && rxIds().indexOf(String(id.value)) === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    block();
  }, true);
  /* 1. click guard (+ Continue with insurance before the generic-item tick) */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (needsAck()) {
      var hit = t.closest(ATC);
      if (hit && !(hit.disabled === true || hit.hasAttribute('disabled'))) {
        e.preventDefault();
        e.stopImmediatePropagation();
        block();
        return;
      }
    }
    var go = t.closest('[data-hmps-go]');
    if (go && !S.sub) {
      e.preventDefault();
      S.subErr = true;
      var g = q('[data-hmps-subgrp]');
      if (g) {
        g.classList.add('is-err');
        var m = g.querySelector('.hmps-err');
        if (m) m.hidden = false;
        reveal(g);
        nudge(g);
        var c = g.querySelector('[data-hmps-sub]');
        if (c) { try { c.focus({ preventScroll: true }); } catch (_e) { /* ignore */ } }
      }
    }
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var pay = t.closest('[data-hmps-pay]');
    if (pay) { setMode(pay.getAttribute('data-hmps-pay') === 'insurance'); return; }
    var om = t.closest('[data-hmps-open]');
    if (om) { e.preventDefault(); openModal(om.getAttribute('data-hmps-open')); return; }
    if (t.closest('[data-hmps-mclose]') || (t.hasAttribute && t.hasAttribute('data-hmps-modal'))) { e.preventDefault(); closeModal(); return; }
    var more = t.closest('[data-hmps-more]');
    if (more) {
      e.preventDefault();
      var g = more.closest('[data-hmps-subgrp]'), m = g ? g.querySelector('.hmps-more') : null;
      if (m) { m.hidden = !m.hidden; S.more = !m.hidden; more.textContent = S.more ? 'Show less' : 'Learn more'; }
      return;
    }
    if (t.closest('[data-hmps-buyretail]')) {
      e.preventDefault();
      setMode(false);
      var co = q('[data-hmps-rxco]');
      setTimeout(function () { reveal(co); nudge(co); }, 60);
      return;
    }
    if (t.closest('[data-hmps-chat]')) {
      e.preventDefault();
      try { if (typeof window.Intercom === 'function') window.Intercom('show'); } catch (_e) { /* ignore */ }
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-hmps-rxack]')) { S.rxAck = !!t.checked; apply(); return; }
    if (t.matches('[data-hmps-state]')) { S.st = t.value || null; check(); return; }
    if (t.matches('[data-hmps-payer]')) { S.py = t.value || null; check(); return; }
    if (t.matches('[data-hmps-sub]')) {
      S.sub = !!t.checked;
      if (S.sub) S.subErr = false;
      var g = t.closest('[data-hmps-subgrp]');
      if (g) {
        g.classList.toggle('is-ok', S.sub);
        if (S.sub) { g.classList.remove('is-err'); var m = g.querySelector('.hmps-err'); if (m) m.hidden = true; }
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeModal();
  });
  function sync() {
    var c = q('[data-hmps-rxack]');
    if (c) S.rxAck = !!c.checked;
    var s = q('[data-hmps-state]'), p = q('[data-hmps-payer]');
    if (s && s.value) S.st = s.value;
    if (p && p.value) S.py = p.value;
    S.res = S.st && S.py ? (inNet(S.py) ? 'in' : 'out') : null;
  }
  function restore() {
    var s = q('[data-hmps-state]'), p = q('[data-hmps-payer]');
    if (s && S.st && !s.value) s.value = S.st;
    if (p && S.py && !p.value) p.value = S.py;
  }
  function boot() { lift(); errMsg(); sync(); result(); apply(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) boot(); });
  document.addEventListener('product-info:loaded', function () { setTimeout(function () { lift(); errMsg(); restore(); result(); apply(); }, 0); });
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
